import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
// import context & actions
import { StoreContext, ACTIONS } from "../context/store";
// import common components
import Typography, { TYPE_ELEMENTS } from "../common-components/Typography";
// import constants
import CONSTANTS from "../utils/constants/constants";

const { HOME, ABOUT_US, APPLICATIONS, TECHNOLOGY, BLOG, CONTACT_US } =
  CONSTANTS.LINKS;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  width: 100%;
  height: 100vh;
  color: #ff4f00;
  padding: 16px;
  box-sizing: border-box;
`;

const NotFoundMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const NavigateButton = styled.div`
  cursor: pointer;
  color: white;
  text-decoration: underline;
  transition: color 0.3s ease;

  &:hover {
    color: #ff4f00;
    transition: color 0.3s ease;
  }
`;

const RouteNudgeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
`;

const RouteList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const { dispatch } = useContext(StoreContext);

  useEffect(() => {
    dispatch({ type: ACTIONS.SET_PAGE_VALIDITY, payload: false });
  }, [dispatch]);

  const handleNavigate = (route) => () => {
    dispatch({ type: ACTIONS.SET_PAGE_VALIDITY, payload: true });
    navigate(route);
  };

  return (
    <PageWrapper>
      <NotFoundMessage>
        <Typography typeElement={TYPE_ELEMENTS.BODY_2}>404</Typography>
        <div
          style={{ width: "2px", height: "16px", backgroundColor: "#FF4F00" }}
        />
        <Typography typeElement={TYPE_ELEMENTS.BODY_2}>
          Page Not Found
        </Typography>
      </NotFoundMessage>
      <RouteNudgeWrapper>
        {location.pathname.includes("tech") ? (
          <>
            <Typography
              typeElement={TYPE_ELEMENTS.BODY_1}
              customColor="white"
              customWeight="500"
            >
              Did you mean to go to any of the following pages?
            </Typography>
            <RouteList>
              <NavigateButton onClick={handleNavigate(TECHNOLOGY.PAGES[0].LINK)}>
                <Typography typeElement={TYPE_ELEMENTS.BODY_2}>
                  Synthetic Aperture Radar
                </Typography>
              </NavigateButton>
              <NavigateButton onClick={handleNavigate(TECHNOLOGY.PAGES[1].LINK)}>
                <Typography typeElement={TYPE_ELEMENTS.BODY_2}>
                  Ground Penetrating Radar
                </Typography>
              </NavigateButton>
              <NavigateButton onClick={handleNavigate(TECHNOLOGY.PAGES[2].LINK)}>
                <Typography typeElement={TYPE_ELEMENTS.BODY_2}>
                  Hyperspectral Imaging
                </Typography>
              </NavigateButton>
              <NavigateButton onClick={handleNavigate(TECHNOLOGY.PAGES[3].LINK)}>
                <Typography typeElement={TYPE_ELEMENTS.BODY_2}>
                  Other Products
                </Typography>
              </NavigateButton>
            </RouteList>
          </>
        ) : (
          (location.pathname.includes("use") ||
            location.pathname.includes("application")) && (
            <>
              <Typography
                typeElement={TYPE_ELEMENTS.BODY_1}
                customColor="white"
                customWeight="500"
              >
                Did you mean to go to any of the following pages?
              </Typography>
              <RouteList>
                <NavigateButton onClick={handleNavigate(APPLICATIONS.LINK)}>
                  <Typography typeElement={TYPE_ELEMENTS.BODY_2}>
                    Use Cases
                  </Typography>
                </NavigateButton>
              </RouteList>
            </>
          )
        )}
        <NavigateButton onClick={handleNavigate(HOME.LINK)}>
          <Typography typeElement={TYPE_ELEMENTS.BODY_2}>Go to Home</Typography>
        </NavigateButton>
      </RouteNudgeWrapper>
    </PageWrapper>
  );
}
